import React from 'react';
import { formatMessageTime } from '../../utils/chatFormatters';

const TimestampDivider = ({ timestamp }) => {
  const formattedTime = formatMessageTime(timestamp);
  if (!formattedTime) return null;

  return (
    <div className="w-full flex justify-center my-4">
      <span
        className="text-xs px-3 py-1"
        style={{ color: 'var(--text-secondary)', opacity: 0.7 }}
      >
        {formattedTime}
      </span>
    </div>
  );
};

export default TimestampDivider;
